import { createFileRoute } from '@tanstack/react-router';

import { PageQuoteImporterExcel } from '@/areas/quote-requests/QuoteRequests/ExcelImporter/PageQuoteImporterExcel';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/quote-requests/importer')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PageQuoteImporterExcel projectId={undefined} negotiationId={undefined} />;
}
